import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useRestaurant } from '../../contexts/restaurant.context';
import { sidebars, toggleSidebar } from '../../store/actions/sidebar.actions';

function SideCategories() {
    const dispatch = useDispatch();
    
    const activeSidebar = useSelector((state) => state.sidebar.active);
    const restaurant = useRestaurant();
    const categories = restaurant.menu_categories;
    
    const [scrollToElement, setScrollToElement] = useState(null);

    useEffect(() => {
        if (!scrollToElement) { return; }
        
        setTimeout(() => {
            scrollToElement.scrollIntoView({
                behavior: 'smooth'
            });

            setScrollToElement(null);
        }, 150);

    }, [scrollToElement]);

    if (!restaurant) {
        return null;
    }

    const handleScrollTo = (e) => {
        e.preventDefault();

        const {
            target
        } = e;

        const parent = target.closest('.nav-category-item');

        let element = null;

        if (target.dataset.categoryId) {
            element = document.querySelector(target.dataset.categoryId);
        }
        else if (parent && parent.dataset.categoryId) {
            element = document.querySelector(parent.dataset.categoryId);
        }
        else {
            element = document.querySelector(target.getAttribute('href'));
        }
        
        // setIsShowCategoriesMenu(false);

        if (!element) {
            return;
        }

        dispatch(toggleSidebar(sidebars.categories));

        setScrollToElement(element);
    };

    return (
        <div id="sideCategories" className={classNames('col sidebar as-shadow categories-sidebar d-none', {show: sidebars.categories === activeSidebar})}>
            <div className="w-100">
                <h2 className="text-danger text-center">Categories</h2>
                <div className="px-2">
                    {categories.map((category, index) => (
                        <div className="mb-2 d-flex nav-category-item" key={index} data-category-id={`#category-${category.id}`} onClick={handleScrollTo}>
                            <div className="card w-100">
                                <div className="card-horizontal">
                                    <div className="card-body">
                                        <h6 className="font-weight-bold text-danger category-item">
                                            {category.name}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default SideCategories;